import React from 'react';
import Box from '@mui/material/Box';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import { permit } from '@lba-dev/package.local-globals/restrictions';

import stopPropagation from '../../utils/stopPropagation';
import { setDialog } from '../../actions/dialog';
import store from '../../store';
import { setNoUrssaf } from '../../actions/artisan';
import notifSystem from '../../notifSystem';


const ExceptionUrssaf = ({
  artisan: { noUrssaf, _id },
  user
}) => {

  const handleToggle = () => {
    if (!noUrssaf) {
      store.dispatch(setDialog({
        name: 'CommentDialog',
        open: true,
        dialogProps: {
          title: 'Justifier l\'exception',
          maxWidth: 'xs',
          middle: true,
        },
        contentProps: {
          label: 'Raison',
          multiline: true,
          minRows: 2,
        },
        actions: [
          {
            children: 'Valider',
            color: 'primary',
            onClick: async ({ text }, close) => {
              if (!text || !text.trim()) {
                return notifSystem.error('Erreur',
                  'Veuillez ajouter une raison');
              }
              await setNoUrssaf(_id, true, user?._id, text);
              return close();
            },
          },
        ],
      }));
      return;
    }
    setNoUrssaf(_id, false, user?._id);
  };

  return (
    <Box display="flex" justifyContent="flex-end" mb={2}>
      {permit(user, { key: 'chefPart' }) && (
        <FormControlLabel
          control={
            <Switch
              checked={!!noUrssaf}
              color={noUrssaf ? 'secondary' : 'primary'}
              onClick={e => {
                stopPropagation(e);
                handleToggle();
              }}
            />
          }
          label="Exception URSSAF"
        />
      )}
    </Box>
  );
};

export default ExceptionUrssaf;
